import { render, staticRenderFns } from "./PrizePicture.vue?vue&type=template&id=cac6402a&scoped=true&"
import script from "./PrizePicture.vue?vue&type=script&lang=js&"
export * from "./PrizePicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizePicture.vue?vue&type=style&index=0&id=cac6402a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac6402a",
  null
  
)

export default component.exports